import React from 'react';
import {BlockBase, ContentData} from '../../interfaces.ts';
import {getContentValue, isBlockTypeCorrect} from '../../utils.ts';
import {useServerProvider} from "../../use-server-provider.tsx";
import {useActiveEditor} from "@inscript/lexical-editor";
import ContentEditable from "../../components/ContentEditable.tsx";

interface HeaderBlockProperties {
  headerLevel: number;
}

interface HeaderBlockContentData {
  headerText: string;
}

const HeaderBlock: React.FC<{ 
  block: BlockBase<HeaderBlockProperties, HeaderBlockContentData>, 
  contentData?: ContentData<HeaderBlockContentData> | null, 
  editable?: boolean, 
  locale: string, 
  fallbackLocale: string 
}> = ({ block, contentData, editable = false, locale, fallbackLocale }) => {
  const { id, properties } = block;
  const onContentChange = useServerProvider<(blockId: string, field: string, value: any) => void>('onContentChange')
  const { headerText } = getContentValue(locale, fallbackLocale, block, contentData)
  const {setActiveEditor} = useActiveEditor();

  if (!isBlockTypeCorrect(block, 'headerBlock')) {
    return null
  }

  if (!headerText) {
    return null;
  }

  const handleInput = (event: string) => {
      if (onContentChange) {
          onContentChange?.value(id, 'headerText', event);
      }
  };

  const tagName = `h${properties.headerLevel}` as keyof React.JSX.IntrinsicElements;
  
  return (
    <ContentEditable
      id={id}
      contentEditable={editable}
      key={id}
      className={id}
      onFocus={() => setActiveEditor(id)}
      data-block-id={id}
      data-field="headerText"
      onChange={handleInput}
      value={headerText}
      tagName={tagName}
    />
  );
};

export default HeaderBlock;
